/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
import React from "react";
import { classNames } from "@plasmicapp/react-web";

export type Icon87IconProps = React.ComponentProps<"svg"> & {
  title?: string;
};

export function Icon87Icon(props: Icon87IconProps) {
  const { className, style, title, ...restProps } = props;
  return (
    <svg
      xmlns={"http://www.w3.org/2000/svg"}
      fill={"none"}
      viewBox={"0 0 10 10"}
      height={"1em"}
      className={classNames("plasmic-default__svg", className)}
      style={style}
      {...restProps}
    >
      {title && <title>{title}</title>}

      <path
        fill={"currentColor"}
        d={
          "M8.577 1.078 3.333 6.322 1.423 4.41a.833.833 0 0 0-1.18 1.179l2.5 2.5a.833.833 0 0 0 1.178 0l5.834-5.833a.833.833 0 0 0-1.179-1.178z"
        }
      ></path>
    </svg>
  );
}

export default Icon87Icon;
/* prettier-ignore-end */
